import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../src/Pages/Home";
import IFix from "../src/Pages/IfixPage";
import ICraft from "../src/Pages/IcraftPage";
import IGreen from "../src/Pages/IgreenPage";
import IAutomate from "../src/Pages/IautomatePage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/ifix" element={<IFix />}></Route>
        <Route path="/icraft" element={<ICraft />}></Route>
        <Route path="/igreen" element={<IGreen />}></Route>
        <Route path="/iautomate" element={<IAutomate />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
